import { useEffect, useState } from 'react';

import { DataFetcher } from '@provider-portal/common/api/apiFetcher/createFetcher';
import {
  ForecastedOfferStatsResult,
  GetPromotionsPermissionsRequest,
  GetPromotionsPermissionsResponse,
  PromotionAccessType,
} from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryCampaignProvider/apis';

export interface PromotionSettings {
  net_revenue_uplift: number;
  promotion_access_type: PromotionAccessType | null;
  is_loading: boolean;
  forecasted_stats?: ForecastedOfferStatsResult;
  paid_visibility_offer_id: number | null;
  has_paid_visibility_offer: boolean;
  has_multiple_paid_visibility_offers: boolean;
  is_sponsored_listing_bundle_discount_enabled: boolean;
  can_view_selected_items_menu_editor: boolean;
}

export function usePromotionSettingsLoader(
  providerId: number,
  promotionPermissionsFetcher: DataFetcher<
    GetPromotionsPermissionsResponse,
    [request: GetPromotionsPermissionsRequest]
  >,
): PromotionSettings {
  const [promotionSettings, setPromotionSettings] = useState<PromotionSettings>({
    net_revenue_uplift: 0,
    promotion_access_type: null,
    is_loading: true,
    paid_visibility_offer_id: null,
    has_paid_visibility_offer: false,
    has_multiple_paid_visibility_offers: false,
    is_sponsored_listing_bundle_discount_enabled: false,
    can_view_selected_items_menu_editor: false,
  });

  useEffect(() => {
    promotionPermissionsFetcher
      .fetch({ provider_id: providerId })
      .then((response) => {
        if (!response) {
          setPromotionSettings((prev) => ({ ...prev, is_loading: false }));
          return;
        }
        const { result } = response;
        setPromotionSettings({
          is_loading: false,
          net_revenue_uplift: result.net_revenue_uplift ?? 0,
          promotion_access_type: result.promotion_access_type,
          forecasted_stats: result.forecasted_stats,
          paid_visibility_offer_id: result.paid_visibility_offer_id,
          has_paid_visibility_offer: result.has_paid_visibility_offer,
          has_multiple_paid_visibility_offers: result.has_multiple_paid_visibility_offers,
          is_sponsored_listing_bundle_discount_enabled:
            result.is_sponsored_listing_bundle_discount_enabled,
          can_view_selected_items_menu_editor: result.can_view_selected_items_menu_editor,
        });
      })
      .catch(() => {});
  }, [promotionPermissionsFetcher, providerId]);
  return promotionSettings;
}
